import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './createStore';

/**
 * 类型化的 Redux hooks
 * 
 * 使用类型化的hooks，提供更好的类型支持
 */
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector = <T>(selector: (state: RootState) => T) =>
  useSelector(selector);

